import React from 'react'
import { Link } from 'react-router-dom'

import { Table } from 'antd'

import {
  EligibleEmployeeInfoDto,
  RenewalClassesDTO,
  RenewalEmployeeDTO,
} from 'core/application/adminDashboard/benefitRenewal/confirmEmployeeClasses/confirmEmployeeClasses'

import Option from 'common/components/dataEntry/components/Option'
import Select from 'common/components/dataEntry/components/Select'
import Icon from 'common/components/general/Icon'

import { Col, Row } from '../../../../common/components'
import { ROUTE_PATHS } from '../../../../common/routePaths'
import { MANAGE_PEOPLE_PATH } from '../../../managePeople'

import 'adminDashboard/managePeople/groupHra/ManagePeople.less'

type eligibleEmployeesRenewalTableProps = {
  translate: (key: string) => string
  renewalClasses: RenewalClassesDTO[]
  employees: EligibleEmployeeInfoDto[]
  submitList: RenewalEmployeeDTO[]
  onSelectedItemsChanged?: (items: RenewalEmployeeDTO[]) => void
}

const EligibleEmployeesRenewalTable: React.FC<eligibleEmployeesRenewalTableProps> = ({
  renewalClasses,
  employees,
  translate,
  submitList,
  onSelectedItemsChanged,
}) => {
  const addToSubmitList = (employeeId: string, renewalClassId: string) => {
    const employee: RenewalEmployeeDTO = { id: employeeId, classId: renewalClassId }
    const temp = submitList
    if (!temp.some((e) => e.id === employeeId)) {
      temp.push(employee)
      if (onSelectedItemsChanged) {
        onSelectedItemsChanged(temp)
      }
    } else {
      const objIndex = temp.findIndex((obj) => obj.id === employeeId)
      temp[objIndex].classId = renewalClassId
      if (onSelectedItemsChanged) {
        onSelectedItemsChanged(temp)
      }
    }
  }

  const columns: any[] = [
    {
      title: translate('admin-dashboard.home.confirm-renewal-classes.first-name'),
      dataIndex: 'firstName',
      key: 'firstName',
      render: (text: string, record: any) => (
        <Link to={`${ROUTE_PATHS.MANAGE_PEOPLE}/view/${record.employeeId}`} target={'_blank'} className="fullname_link">
          <Row align={'middle'} gutter={8}>
            <Col className="user_avatar_wrapper">
              <Icon className="center_avatar" type="user"></Icon>
            </Col>
            <Col>{record.firstName}</Col>
            <Col>{record.lastName}</Col>
          </Row>
        </Link>
      ),
    },
    {
      title: translate('admin-dashboard.home.confirm-renewal-classes.work-email'),
      dataIndex: 'workEmail',
      key: 'workEmail',
    },
    {
      title: translate('admin-dashboard.home.confirm-renewal-classes.employment-status'),
      dataIndex: 'employmentStatus',
      key: 'employmentStatus',
    },
    {
      title: translate('admin-dashboard.home.confirm-renewal-classes.employee-class'),
      dataIndex: 'employeeClass',
      key: 'employeeClass',
      render: (text: string, record: any) => (
        <Select
          value={renewalClasses?.length == 1 ? [renewalClasses[0].id] : undefined}
          disabled={renewalClasses?.length == 1}
          onChange={(value) => addToSubmitList(record.employeeId, value)}
        >
          {renewalClasses?.map((renewalClass: RenewalClassesDTO) => (
            <Option key={renewalClass.id} value={renewalClass.id}>
              {renewalClass.name}
            </Option>
          ))}
        </Select>
      ),
    },
  ]

  return <Table dataSource={employees} columns={columns} pagination={false} scroll={{ x: 1000 }} />
}

export default EligibleEmployeesRenewalTable
